import AddNewDeviceForm from '../../../forms/AddNewDeviceForm/AddNewDeviceForm'


const AddNewDevice = () => {
	return (
		<>
			<AddNewDeviceForm />
		</>
	)
}

export default AddNewDevice
